import React from 'react'
import MaterialSymbol from '../material-symbol'

const PersonAdd = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="person_add" {...props} />
))

PersonAdd.displayName = 'PersonAdd'

export default PersonAdd
